<div class="h-full bg-white">
    <div class="mb-4 flex flex-row items-center justify-center bg-white pt-6" *ngIf="env.IS_MOBILE_APP">
        <ridango-ui-back-button
            class="absolute left-4"
            (click)="handleBackClicked()"
            classIcon="w-7 h-7"></ridango-ui-back-button>
        <h1 class="var-app-light:font-bold text-center text-base font-semibold leading-5">
            {{ 'FORGOT_PASSWORD' | translate }}
        </h1>
    </div>
    <rwidget-alert></rwidget-alert>
    <div class="px-9 pt-10">
        <p class="text-items__description" innerHtml="{{ 'PASSWORD_NEW_INSTRUCTIONS' | translate }}"></p>
        <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>
        <form [formGroup]="emailForm" (ngSubmit)="submit()" autocomplete="on">
            <mat-form-field class="full-width" appearance="outline">
                <mat-label [attr.aria-label]="'LOCAL_LABEL_EMAIL' | translate" aria-hidden="true">{{
                    'PH_EMAIL' | translate
                }}</mat-label>
                <input
                    [attr.aria-label]="'LOCAL_LABEL_EMAIL' | translate"
                    matInput
                    required="true"
                    ridangoInput
                    formControlName="email"
                    ridangoAutofill
                    type="email"
                    name="email"
                    title="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
                    autocomplete="username"
                    ridangoUntouchOnFocusout />

                <mat-error *ngIf="isTouched">
                    {{
                        isRequired
                            ? ('LOCAL_INPUT_EMAIL_MISSING' | translate)
                            : ('LOCAL_INPUT_VALIDATION_EMAIL' | translate)
                    }}
                </mat-error>
            </mat-form-field>
            <!--      To trigger IOS autocomplete      -->
            <input type="hidden" name="password" ridangoInput ridangoAutofill autocomplete="current-password" />
            <button
                class="gl-app-light:bg-[var(--color-primary)] vl-app-light:bg-[var(--btn-primary-color)] sr-app-light:bg-[var(--color-secondary)] var-app-light:bg-[var(--color-secondary)] orb-app-light-dark:h-16 mt-4 h-12 w-full rounded-lg bg-[var(--color-primary)] dark:bg-contrast-yellow dark:text-contrast-black"
                [attr.aria-label]="'BTN_RESET_PASSWORD' | translate"
                [disabled]="loading$ | async"
                type="submit">
                <ion-label
                    class="gl-app-light:text-[var(--color-secondary)] jk-light:text-white sr-app-light:text-white pn-app-light:text-white pn-light:text-white pn-app-light:text-white var-app-light:text-primary orb-app-light-dark:font-semibold text-base font-bold normal-case text-contrast-black dark:text-contrast-black">
                    {{ 'BTN_RESET_PASSWORD' | translate }}
                </ion-label>
            </button>
        </form>
    </div>
</div>
